export enum AvailabilityTypes {
  SHOW_ALWAYS_IN_STOCK = 'SHOW_ALWAYS_IN_STOCK',
  IN_STOCK_IMMEDIATE_SHIPPING = 'IN_STOCK_IMMEDIATE_SHIPPING',
  SUPPLIER_STOCK_SHIPPING_WITHIN_48H = 'SUPPLIER_STOCK_SHIPPING_WITHIN_48H',
  SUPPLIER_STOCK_SHIPPING_WITHIN_THREE_FOUR_DAYS = 'SUPPLIER_STOCK_SHIPPING_WITHIN_THREE_FOUR_DAYS',
  SUPPLIER_STOCK_SHIPPING_WITHIN_FOUR_SIX_DAYS = 'SUPPLIER_STOCK_SHIPPING_WITHIN_FOUR_SIX_DAYS',
  SUPPLIER_STOCK_SHIPPING_WITHIN_SIX_EIGHT_DAYS = 'SUPPLIER_STOCK_SHIPPING_WITHIN_SIX_EIGHT_DAYS',
  SUPPLIER_STOCK_SHIPPING_WITHIN_TEN_TWELVE_DAYS = 'SUPPLIER_STOCK_SHIPPING_WITHIN_TEN_TWELVE_DAYS',
  NON_STOCK_ITEM = 'NON_STOCK_ITEM',
  STOCK_SHORTAGE_ITEM = 'STOCK_SHORTAGE_ITEM',
  ESTIMATED_IN_STORE_BY_DATE = 'ESTIMATED_IN_STORE_BY_DATE',
  IMMEDIATE_DOWNLOAD = 'IMMEDIATE_DOWNLOAD',
  NON_STOCK_ITEM_EARLIEST_DATE = 'NON_STOCK_ITEM_EARLIEST_DATE',
  WEEKS_FROM_ORDER_DATE = 'WEEKS_FROM_ORDER_DATE',
  NOT_MIGRATED_TYPE = 'NOT_MIGRATED_TYPE',
  PRODUCT_AVAILABILITY_OUT_OF_STOCK_COMING_SOON = 'PRODUCT_AVAILABILITY_OUT_OF_STOCK_COMING_SOON',
}

export enum AvailabilityStatusIconColor {
  Green = 'green',
  Orange = 'orange',
  Gray = 'gray',
  White = 'white'
}

export type AvailabilityTypeKeys = keyof typeof AvailabilityTypes
export type AvailabilityType = (typeof AvailabilityTypes)[AvailabilityTypeKeys]

export type TranslationStockMapKeys = AvailabilityTypeKeys | 'QUANTITY_LEFT' | 'BID_SUFFIX'
export type TranslationStockMapStatesValues = { default: string; quantityLeft?: string, tooltip?: string }
